'use client';
import styled from 'styled-components';

export const StyledFieldset = styled.fieldset`
  border-width: 0px;
  width: 100%;
  padding-top: 0px;
  padding-bottom: 0px;
`;

export const CardContainer = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: ${({ direction }) => direction};
`;
